import(/* webpackMode: "eager" */ "/home/runner/work/hire/hire/apps/web/app/global-error.tsx");
